// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__3ywAb","form":"styles_form__3jCqg"};